import { isEmpty } from "lodash";
import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AuthContext from "../../context/AuthContext";
import constants from "../../utils/constants";
const Hierarchy = (props) => {
 
  let { user } = useContext(AuthContext);
  const [profile, setProfile] = useState({});
  useEffect(() => {
    setProfile(props?.results?.balance || {});
  }, [props]);

  let userStatus = {
    owner: "OW",
    sub_owner: "SOW",
    super_admin: "SSSSS",
    admin: "SSSS",
    sub_admin: "SSS",
    senior_super: "SS",
    super_agent: "SUP",
    agent: "MA",
    user: "PL",
  };

  if (user?.userType === "sub_owner") {
    userStatus = {
      sub_owner: "SOW",
      super_admin: "SSSSS",
      admin: "SSSS",
      sub_admin: "SSS",
      senior_super: "SS",
      super_agent: "SUP",
      agent: "MA",
      user: "PL",
    };
  } else if (user?.userType === "super_admin") {
    userStatus = {
      super_admin: "SSSSS",
      admin: "SSSS",
      sub_admin: "SSS",
      senior_super: "SS",
      super_agent: "SUP",
      agent: "MA",
      user: "PL",
    };
  } else if (user?.userType === "admin") {
    userStatus = {
      admin: "SSSS",
      sub_admin: "SSS",
      senior_super: "SS",
      super_agent: "SUP",
      agent: "MA",
      user: " PL",
    };
  } else if (user?.userType === "sub_admin") {
    userStatus = {
      sub_admin: "SSS",
      senior_super: "SS",
      super_agent: "SUP",
      agent: "MA",
      user: "PL",
    };
  } else if (user?.userType === "senior_super") {
    userStatus = {
      senior_super: "SS",
      super_agent: "SUP",
      agent: "MA",
      user: "PL",
    };
  } else if (user?.userType === "super_agent") {
    userStatus = {
      super_agent: "SUP",
      agent: "MA",
      user: "PL",
    };
  }else if (user?.userType === "agent") {
    userStatus = {
    
      agent: "MA",
      user: "PL",
    };
  }
 
  // console.log(profile,"profile",user.userType in profile)

  return (
    <div className="agent-path mb-1">
      {user.userType in profile ? (
       
        <ul className="m-0 list-unstyled">
          {Object.keys(userStatus).map((u_type) => {
            //  console.log('u_type0',u_type)
            return !isEmpty(profile[u_type]) && u_type != "owner" ? (
              <li>
                <Link
                  to={`/${profile[u_type]._id}/${
                    profile[u_type]?.userType || ""
                  }`}
                >
                  <span className={userStatus[u_type]}>
                    {userStatus[u_type]}
                  </span>
                  <strong>{profile[u_type]?.username || ""}</strong>
                </Link>
              </li>
            ) : null;
          })}
          {profile?.userType && (
            <>
              <li>
                <Link to={`/${profile._id}/${profile?.userType || ""}`}>
                  <span className={userStatus[profile?.userType]}>
                    {constants.user_status[profile?.userType]}
                  </span>
                  <strong>{profile?.username || ""}</strong>
                </Link>
              </li>
            </>
          )}
        </ul>
      ) : null}
    </div>
  );
};

export default Hierarchy;
